import units from "@/base/lang/ru/units";

function stripHtml(html) {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.innerText;
}

let unitNames = [
    'u',
    'g',
    'kg',
    't',
    'l',
    'cbm',
    'm',
    'sm',
    'mm',
    'pkg',
    'jr',
    'btl',
];

let unitFullNames = {
    m: 'meter',
    sm: 'centimeter',
    mm: 'millimeter',

    t: 'ton',
    kg: 'kilogram',
    g: 'gram',

    u: 'unit',

    cbm: 'cube_meter',
    l: 'liter',

    pkg: 'package',
    jr: 'jar',
    btl: 'bottle',
};

let helper = {
    plural:   function (str, number = 0) {
        let value = str.split('|');
        if (!value instanceof Array) {
            return str;
        }
        if (number === 0) {
            return value.length > 3 ? value[3] : str;
        }
        if (!Number.isInteger(number)) {
            return value.length > 1 ? value[1] : str;
        }
        let n = Math.abs(number);
        n %= 10;
        if (n >= 5 || n === 0) {
            return value.length > 2 ? value[2] : str;
        }
        if (n === 1) {
            return value[0];
        }
        if (n > 1 && n < 5) {
            return value.length > 1 ? value[1] : str;
        }
        return str;
    },
    ucfirst: function (str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    },
    allUnits: function () {
        return unitNames.map(function (unitName) {
            return {
                name: unitName,
                title: units[unitName],
                fullTitle: helper.plural(units[unitFullNames[unitName]], 1),
                fullTitleMany: helper.plural(units[unitFullNames[unitName]]),
            }
        });
    },
    getUnitTitle: function (unitName, isFull = false, number = 0) {
        if (!isFull) {
            return units[unitName];
        }
        return helper.plural(units[unitFullNames[unitName]], number);
    },
    removeObjectFromArray: function(arr, key, value) {
        for (let i = arr.length - 1; i >= 0; i--) {
            if (arr[i][key] === value) {
                arr.splice(i, 1);
            }
        }
        return arr;
    },
    getCommissionValueTypeTitle: function (commission) {
        if (commission.value_type === 'percent') {
            return '%';
        }
        if (commission.value_type === 'fix') {
            return ' руб.';
        }
    },
    randomString: function(length) {
        const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        let result = '';
        for (let i = 0; i < length; i++) {
            const randomIndex = Math.floor(Math.random() * charset.length);
            result += charset[randomIndex];
        }
        return result;
    },
    sortArray: function (array, key, direction = 'asc') {
        return array.slice().sort((a, b) => {
            const getValue = (obj, keyPath) => keyPath.split('.').reduce((acc, part) => acc && acc[part], obj);

            const aValue = getValue(a, key);
            const bValue = getValue(b, key);

            if (direction === 'asc') {
                if (aValue < bValue) return -1;
                if (aValue > bValue) return 1;
            } else if (direction === 'desc') {
                if (aValue > bValue) return -1;
                if (aValue < bValue) return 1;
            }

            return 0;
        });
    },
    sum: function (arr, field) {
        let sum = 0;
        arr.forEach(function (item) {
            sum += parseFloat(item[field] || 0);
        });
        return sum;
    },
    formatNumber: function (number, separator = ' ', decimalPlaces = 0) {
        number = parseFloat(number);
        const fixedNumber = number.toFixed(decimalPlaces);
        const parts = fixedNumber.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, separator);
        return parts.join('.');
    },
    getChanges: function (from, to) {
        if (!from) {
            from = {};
        }
        if (!to) {
            to = {};
        }

        const changes = {};

        const allKeys = new Set([...Object.keys(from), ...Object.keys(to)]);

        for (const key of allKeys) {
            const oldValue = from.hasOwnProperty(key) ? from[key] : null;
            const newValue = to.hasOwnProperty(key) ? to[key] : null;

            if (oldValue !== newValue) {
                changes[key] = {
                    field_name: key,
                    from: oldValue,
                    to: newValue
                };
            }
        }

        return changes;
    },
    addressString: function (address, showRegion = true, showArea = true, showStreet = true, showHouse = true) {
        let regionWithType = showRegion && address.region_with_type ? address.region_with_type : '';

        let areaWithType = '';
        if (regionWithType) {
            areaWithType = showArea && address.area_with_type ? ', ' + address.area_with_type : '';
        } else {
            areaWithType = showArea && address.area_with_type ? address.area_with_type : '';
        }

        let cityWithType = (regionWithType || areaWithType) ? ', ' + address.city_with_type : address.city_with_type;

        let result = regionWithType + areaWithType + cityWithType;

        result += showStreet && address.street_with_type ? ', ' + address.street_with_type : '';
        result += showStreet && showHouse && address.house ? ', ' + address.house : '';
        result += showStreet && showHouse && address.apartment ? ', ' + address.apartment : '';

        return result;
    },
    copyToClipboard(text) {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'absolute';
        textarea.style.left = '-9999px';
        document.body.appendChild(textarea);
        textarea.select();
        try {
            document.execCommand('copy');
        } catch (err) {
            console.error('Ошибка при копировании', err);
        }
        document.body.removeChild(textarea);
    },
    async copyHtmlToClipboard(html) {
        const div = document.createElement('div');
        div.innerHTML = html;
        await navigator.clipboard.write([
            new ClipboardItem({
                'text/html': new Blob([html], { type: 'text/html' }),
                'text/plain': new Blob([div.innerText], { type: 'text/plain' }),
            })
        ]);
    },
    altKeyboardMap(string) {
        let map = {
            'q': 'й', 'w': 'ц', 'e': 'у', 'r': 'к', 't': 'е', 'y': 'н', 'u': 'г', 'i': 'ш', 'o': 'щ', 'p': 'з', '[': 'х', ']': 'ъ', 'a': 'ф', 's': 'ы', 'd': 'в', 'f': 'а', 'g': 'п', 'h': 'р', 'j': 'о', 'k': 'л', 'l': 'д', ';': 'ж', '\'': 'э', 'z': 'я', 'x': 'ч', 'c': 'с', 'v': 'м', 'b': 'и', 'n': 'т', 'm': 'ь', ',': 'б', '.': 'ю',
            'й': 'q', 'ц': 'w', 'у': 'e', 'к': 'r', 'е': 't', 'н': 'y', 'г': 'u', 'ш': 'i', 'щ': 'o', 'з': 'p', 'х': '[', 'ъ': ']', 'ф': 'a', 'ы': 's', 'в': 'd', 'а': 'f', 'п': 'g', 'р': 'h', 'о': 'j', 'л': 'k', 'д': 'l', 'ж': ';', 'э': '\'', 'я': 'z', 'ч': 'x', 'с': 'c', 'м': 'v', 'и': 'b', 'т': 'n', 'ь': 'm', 'б': ',', 'ю': '.'
        };
        return string.split('').map(c => map[c] || c).join('');
    },
    cleanPhone(input, withPlus = true) {
        if (!input) {
            return '';
        }
        let digits = input.toString().replace(/\D/g, '');
        if (digits.startsWith('8')) {
            digits = '7' + digits.slice(1);
        }
        return withPlus ? '+' + digits : digits;
    },
    formatPhone(input) {
        let digits = this.cleanPhone(input, false);

        let result = '+';

        if (digits.length > 0) {
            result += digits[0];
        }
        if (digits.length > 1) {
            result += ' (' + digits.slice(1, Math.min(4, digits.length));
        }
        if (digits.length >= 4) {
            result += ')';
        }
        if (digits.length > 4) {
            result += ' ' + digits.slice(4, Math.min(7, digits.length));
        }
        if (digits.length > 7) {
            result += '-' + digits.slice(7, Math.min(9, digits.length));
        }
        if (digits.length > 9) {
            result += '-' + digits.slice(9, Math.min(11, digits.length));
        }

        return result;
    },
    secondsToTimeString(seconds, beforeHours = '', afterHours = ':', afterMinutes = '') {
        if (seconds < 60) {
            return 'Меньше минуты';
        }

        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const formattedHours = hours ? beforeHours + hours + afterHours : '';

        return seconds
            ? formattedHours + (minutes < 10 ? '0' + minutes : minutes) + afterMinutes
            : '';
    },
    generatePassword(length = 12) {
        const lowercase = 'abcdefghijklmnopqrstuvwxyz';
        const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        const numbers = '0123456789';
        const special = '!@#$%()_.?';
        const all = lowercase + uppercase + numbers + special;

        let password = '';
        password += lowercase[Math.floor(Math.random() * lowercase.length)];
        password += uppercase[Math.floor(Math.random() * uppercase.length)];
        password += numbers[Math.floor(Math.random() * numbers.length)];
        password += special[Math.floor(Math.random() * special.length)];

        for (let i = password.length; i < length; i++) {
            password += all[Math.floor(Math.random() * all.length)];
        }

        return password.split('').sort(() => Math.random() - 0.5).join('');
    },
}

export default helper
